import styled from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';

export const ProhibitedListItemContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`;

export const ProhibitedListItemDescriptionContainer = styled.div`
  flex: 1;
  margin-left: 0.8rem;
`;

export const ProhibitedListItemDescription = styled.span`
  font-size: ${FontSizes.normal};
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.baseColors.grey100};
`;

export const ProhibitedListItemTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.4rem;
  gap: 0.4rem;
`;
